<ejs-tab *ngIf="tabs" [animation]="animation" (created)="onCreated()">
  <e-tabitems>
    <e-tabitem *ngFor="let item of tabs.toArray()">
      <ng-template #headerText>
        {{ item.title }}
      </ng-template>
      <ng-template #content>
        <ng-container
          *ngTemplateOutlet="item.template?.templateRef || null"
        ></ng-container>
      </ng-template>
    </e-tabitem>
  </e-tabitems>
</ejs-tab>
